import { render, staticRenderFns } from "./DeliveryPointPhotos.vue?vue&type=template&id=50cedd9d&scoped=true"
import script from "./DeliveryPointPhotos.vue?vue&type=script&lang=js"
export * from "./DeliveryPointPhotos.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPointPhotos.vue?vue&type=style&index=0&id=50cedd9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cedd9d",
  null
  
)

export default component.exports